'use client'

import React from 'react';
import {
    Flex,
    IconButton,
    Avatar,
    HStack,
    Text,
    Menu,
    MenuButton,
    MenuList,
    MenuItem,
    MenuDivider,
    useColorModeValue,
} from '@chakra-ui/react';
import { NavLink as RouterLink } from 'react-router-dom';
import { FiMenu, FiBell, FiChevronDown } from 'react-icons/fi';
import {AuthContextType} from "../../features/auth/types/auth.types";
import { useAuth } from "../../features/auth/hooks/useAuth";

interface HeaderProps {
    onOpen: () => void;
}

export default function Header({ onOpen }: HeaderProps) {
    const linkHoverBg = useColorModeValue('white', 'gray');
    const linkColor = useColorModeValue('white', 'gray.200');
    const { getFullName, login, logout, isAuthenticated }: AuthContextType = useAuth();

    return (
        <Flex
            as="header"
            w="100%"
            h="80px"
            px={4}
            align="center"
            bg={useColorModeValue(
                'radial-gradient(circle at bottom right, #420178 0%, #08000f 100%)',
                'radial-gradient(circle at top left, #05020d 0%, #fc8efe 100%)'
            )}
            borderBottom="1px solid"
            borderColor={useColorModeValue('gray.200', 'gray.700')}
        >
            {/* Bouton de menu visible uniquement en mobile */}
            <IconButton
                aria-label="Open Menu"
                variant="outline"
                display={{ base: 'flex', md: 'none' }}
                onClick={onOpen}
                icon={<FiMenu />}
            />

            <HStack spacing={6} flex="1" justify="flex-end">
                <Menu>
                    <MenuButton>
                        <HStack>
                            <Avatar size="xs" src="https://upload.wikimedia.org/wikipedia/commons/4/4b/User-Pict-Profil.svg" />
                            <Text display={{ base: 'none', md: 'block' }} color={linkColor}
                                  _hover={{ bg: linkHoverBg,  transform: 'scale(1.05)',
                                      color: 'black'}}
                            >{getFullName()}</Text>
                            <FiChevronDown />
                        </HStack>
                    </MenuButton>
                    <MenuList>
                        {isAuthenticated && (
                            <>
                                <MenuDivider />
                                <MenuItem onClick={logout}>Déconnexion</MenuItem>
                            </>
                        )}
                        {!isAuthenticated && (
                            <MenuItem onClick={login}>Connexion</MenuItem>
                        )}
                    </MenuList>
                </Menu>
            </HStack>
        </Flex>
    );
}
